import * as React from "react";
export default class ProductSearchButton extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return this.props.supplier.DisplayInventory ? (React.createElement("div", { className: "store-product-search" },
            React.createElement("div", { className: "store-product-search__wrap" },
                React.createElement("a", { href: `/Licensee/Products/${this.props.supplier.Number}`, className: this.props.buttonClass }, "Search Store Products")))) : null;
    }
}
;
//# sourceMappingURL=product-search.js.map